import React, { useState, useEffect } from 'react';
import { useMutation, gql } from '@apollo/client';

const CREATE_PRODUCT = gql`
  mutation ($sku: String!, $name: String!, $price: Float!, $inventory: Int!) {
    createProduct(sku: $sku, name: $name, price: $price, inventory: $inventory) {
      id
      sku
      name
      price
      inventory
    }
  }
`;

const UPDATE_PRODUCT = gql`
  mutation ($id: ID!, $sku: String!, $name: String!, $price: Float!, $inventory: Int!) {
    updateProduct(id: $id, sku: $sku, name: $name, price: $price, inventory: $inventory) {
      id
      sku
      name
      price
      inventory
    }
  }
`;

export default function ProductForm({ onSuccess, editProduct, onCancelEdit }) {
  const [sku, setSku] = useState('');
  const [name, setName] = useState('');
  const [price, setPrice] = useState('');
  const [inventory, setInventory] = useState('');

  const [createProduct] = useMutation(CREATE_PRODUCT);
  const [updateProduct] = useMutation(UPDATE_PRODUCT);

  useEffect(() => {
    if (editProduct) {
      setSku(editProduct.sku);
      setName(editProduct.name);
      setPrice(editProduct.price.toString());
      setInventory(editProduct.inventory.toString());
    }
  }, [editProduct]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editProduct) {
        await updateProduct({
          variables: { 
            id: editProduct.id,
            sku, 
            name, 
            price: parseFloat(price), 
            inventory: parseInt(inventory) 
          },
        });
      } else {
        await createProduct({
          variables: { sku, name, price: parseFloat(price), inventory: parseInt(inventory) },
        });
      }
      onSuccess();
      setSku('');
      setName('');
      setPrice('');
      setInventory('');
      if (onCancelEdit) onCancelEdit();
    } catch (err) {
      console.error('Error saving product:', err);
    }
  };

  const handleCancel = () => {
    setSku('');
    setName('');
    setPrice('');
    setInventory('');
    if (onCancelEdit) onCancelEdit();
  };

  return (
    <form onSubmit={handleSubmit}>
      <input placeholder="SKU" value={sku} onChange={(e) => setSku(e.target.value)} required />
      <input placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} required />
      <input placeholder="Price" type="number" step="0.01" value={price} onChange={(e) => setPrice(e.target.value)} required />
      <input placeholder="Inventory" type="number" value={inventory} onChange={(e) => setInventory(e.target.value)} required />
      <button type="submit">{editProduct ? 'Update Product' : 'Add Product'}</button>
      {editProduct && <button type="button" onClick={handleCancel}>Cancel</button>}
    </form>
  );
}
